module.exports = __webpack_public_path__ + "img/photo-22.062d630b.jpg";